import React, { Component } from 'react';
import StoreFilter from 'containers/Store/StoreFilter';

const css = oxygenCss({
  root: {}
});

class StoreFilterModule extends Component {
  render() {
    return (
      <div className={css.root}>
        <StoreFilter {...this.props} />
      </div>
    );
  }
}

export default StoreFilterModule;



// WEBPACK FOOTER //
// ./src/js/components/Store/Modules/StoreFilterModule.js